import * as Sentry from "@sentry/browser";

const jQuery = window.jQuery;

const ajax = {
  beforeSend: beforeSend,
  contentType: `application/json; charset=utf-8`, // set Ajax calls to send JSON data;
  crossSiteProtectionCookieName: `csrftoken`, // CORS cookie to pass in Ajax calls;
  getCookie: getCookie,
  onFail: onFail,
  onFailWithExceptions: onFailWithExceptions
};

export default ajax;

//

// function to attach to Ajax calls, it adds headers to enable CORS;
function beforeSend(request) {
  request.setRequestHeader(
    `X-CSRFToken`,
    getCookie(ajax.crossSiteProtectionCookieName)
  );
}

// simple get cookie value function;
// React doesn’t set cookies, so we don't need a full featured cookie lib;
function getCookie(cookieName) {
  const match = document.cookie.match(new RegExp(cookieName + `=([^;]+)`));

  if (match) return match[1];
}

// Ajax failure function, attached to all Ajax calls;
// will display the error message in a Bootstrap `alert` component;
function onFail(jqXHR) {
  const alertContainer = jQuery(`.alert-container`);
  const json = jqXHR.responseJSON;

  // truncate the text error message if there is one;
  // the full error message is too large to display;
  let text = jqXHR.responseText ? jqXHR.responseText.substring(0, 800) : null;
  if ((jqXHR.status >= 500 && jqXHR.status <= 505) || text === null) {
    // display a friendlier message but log the error in the console
    console.error(text);
    Sentry.captureMessage(text);
    text = "Something went wrong. Please refresh the page.";
  }

  // create the container for the error message;
  const $alert = jQuery(`
    <div class="alert alert-danger alert-dismissible" role="alert">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <div class="alert__messages"></div>
    </div>`);

  // if there is an error in the API (not a server error);
  if (json) {
    Object.keys(json).forEach(key => {
      const $message = `<span><strong>${key.toUpperCase()}:</strong> ${
        json[key]
      }</span>`;

      $alert.find(`.alert__messages`).prepend($message);
    });

    // if there is a server error;
  } else {
    const $message = `<pre>${text}</pre>`;

    $alert.find(`.alert__messages`).prepend($message);
  }

  // now that the error message has been determined and built, insert it into the page;
  // but only if it's not already there (if it's a new error)
  // also changing the order of the errors (latest last)
  // this is outside of React;

  alertContainer.children().each((index, alert) => {
    jQuery(alert).text() === $alert.text() && jQuery(alert).remove();
  });

  alertContainer.prepend($alert);
}

// Ajax failure function, attached to SOME Ajax calls;
// will forward to the onFail function if the errors are not expected;
function onFailWithExceptions(jqXHR) {
  const json = jqXHR.responseJSON;
  let ignoreThisError = false;

  // if there is an error in the API (not a server error);
  if (json) {
    Object.keys(json).forEach(key => {
      const jsonKey = json[key].toLowerCase();

      // user hasn’t logged in yet;
      if (jsonKey.indexOf(`authentication`) > -1) {
        ignoreThisError = true;
      }
    });
  }

  // only process errors if it’s not an authentication issue, or the user hasn’t selected a station;
  if (ignoreThisError === false) {
    onFail(jqXHR);
  }
}
